import { render } from "./TrashCanOutline.vue.js?vue&type=template&id=3daa0f14!=!../vue-loader/dist/index.js??ruleSet[0]!./TrashCanOutline.vue?vue&type=template&id=3daa0f14"
import script from "./TrashCanOutline.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./TrashCanOutline.vue?vue&type=script&lang=js"
export * from "./TrashCanOutline.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./TrashCanOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__